<script>
	export let message;
</script>


<div>{message}</div>
